export const REGULATORY_FILLING = 1;
export const CEP = 1;
export const US_DMF = 2;
export const KDMF = 3;
export const JDMF = 4;
export const CDMF = 5;
export const WRITTEN_CONFIRMATION = 5;
export const GLOBAL_CONSULTATION = 13;
export const INDIAN_EXPORTS = 8;
export const INDIAN_IMPORTS = 9;
export const MEXICAN_EXPORTS = 10;
export const MEXICAN_IMPORTS = 11;
export const BRAZIL_EXPORTS = 12;
export const FDF_US = 14;
export const FDF_WORLDWIDE = 15;
export const BRAZIL_IMPORTS = 16;
